import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EditableFieldService {
  constructor(private http: HttpClient) {}

  requestUpdate(url: string, params = {}) {
    return this.http.put<unknown>(url, { ...params });
  }
}
